import { SLACE_GENDERS } from 'cpool-constants';
import { z } from 'zod';

import { schemaSlaceContactAddress } from '../SlaceContactAddress';

export const schemaCreateContactBody = z.object({
    address: schemaSlaceContactAddress.optional(),
    avatars: z
        .object({
            additional: z.record(z.string(), z.string()).optional(),
            primary: z.string().optional(),
        })
        .optional(),
    // Default is yyyy-mm-dd
    birthdate: z.string().optional(),
    care_of: z.string().optional(),
    // Overridden with birthdate data if provided
    day_of_birth: z.number().optional(),
    email: z.string().optional(),
    external_ids: z.record(z.unknown()).optional(),
    first_name: z.string().optional(),
    gender: z.nativeEnum(SLACE_GENDERS).optional(),
    languages: z
        .object({
            additional: z.record(z.string(), z.string()).optional(),
            primary: z.string().optional(),
        })
        .optional(),
    last_name: z.string().optional(),
    lifetime_loyalty_points: z.record(z.string(), z.number()).optional(),
    loyalty_points: z.record(z.string(), z.number()).optional(),
    mobile: z.string().optional(),
    mobile_verified: z.boolean().optional(),
    mobile_verified_at: z.string().optional(),
    // Overridden with birthdate data if provided
    month_of_birth: z.number().optional(),
    name: z.string(),
    strict_attributes: z
        .record(
            z.string(),
            z.object({
                type: z.union([z.string(), z.number(), z.date()]).optional(),
                value: z.unknown().optional(),
            }),
        )
        .optional(),
    timezone: z.string().optional(),
});

export type SchemaCreateContactBody = z.infer<typeof schemaCreateContactBody>;
